/********************************************************
* Link Scroll Animate
*
* Selects all links with hashes and 
* animates page scroll to element id
*
********************************************************/


/**********************************************
 DEPENDANCIES
**********************************************/

// required jquery but that is in global space already because of WordPress


/**********************************************
 VARIABLE DECLARATION
**********************************************/

var self = {};
var hash_mod = "";
var menu_identifier = "";




/**********************************************
 HELPER FUNCTIONS
**********************************************/



/**********************************************
 PRIVATE FUNCTIONS
**********************************************/


var getBump = function() {
    var header_position = $('header').css("position");
    return (header_position == 'fixed') ? $('header').height() : 0;
}



var onScroll = function(e) {
    var scrollPos = $(document).scrollTop();

    $(menu_identifier + ' a').each(function () {
        var currLink = $(this);

        if (currLink.attr("href").indexOf('#') >= 0) {
            var hash = currLink.attr("href").split("#").pop();
            
            if ($('#' + hash + hash_mod).length != 0) {
                var refElement = $('#' + hash + hash_mod);

                if (refElement.position().top <= (scrollPos + getBump() + 5) && refElement.position().top + refElement.height() > (scrollPos + getBump() + 5)) {
                    $(menu_identifier + ' li a').parent().removeClass("current-menu-item");
                    currLink.parent().addClass("current-menu-item");
                }
                else{
                    currLink.parent().removeClass("current-menu-item");
                }
            }
        }
    });

    // if not matching any id then try to find base menu item for matching page
    if ( $(".current-menu-item").length == 0 ) {
        $(menu_identifier + ' [href="' + document.location.href + '"]').parent().addClass("current-menu-item")
    }
}


/**********************************************
 PUBLIC FUNCTIONS
**********************************************/

self.init = function( hashMod, menuIdentifier, onActive, onComplete ) {
	hash_mod = hashMod;
    menu_identifier = menuIdentifier;
    

    // If page jumped to with hashtag link
    if(document.location.hash.indexOf("#") >= 0){
        var hash = document.location.hash;
        if ((hash == '#') || (hash == '#0')) return;

        // Figure out element to scroll to
        var target = $(hash + hashMod);
        //target = target.length ? target : $('[id=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
            // Only prevent default if animation is actually gonna happen
            //event.preventDefault();
            if (onActive) onActive();

            setTimeout( function() {
                $('html, body').animate({
                    scrollTop: (target.offset().top - getBump())
                }, 1000, function() {
                    if (onComplete) onComplete();
                });
            },500);
        }
    }


    // If anchor with on page div call
	$('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
            // On-page links
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                // Figure out element to scroll to
                var target = $(this.hash + hashMod);
                target = target.length ? target : $('[id=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    if (onActive) onActive();

                    var header_position = $('header').css("position");
                    var bump = (header_position == 'fixed') ? $('header').height() : 0;

                    $('html, body').animate({
                        scrollTop: target.offset().top - bump
                    }, 1000, function() {

                    	if (onComplete) onComplete();

                        // Callback after animation
                        // Must change focus!
                        /*var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                        } 
                        else {
                            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        };*/
                    });
                }
            }
        });


    // Update Wordpress menu as scrolling (if applicable)
    onScroll();
    $(document).on("scroll", onScroll);
}


/**********************************************
 MODULE EXPORT
**********************************************/
module.exports = self;



//////////////////
// WEBPACK FOOTER
// ..-src/javascript/modules/link_scroll_animate.js
// module id = 2
// module chunks = 0